const installMediaQueryWatcher = (mediaQuery, changedCallback) => {
  const mq = window.matchMedia(mediaQuery);
  mq.addEventListener('change', e => changedCallback(e.matches));
  changedCallback(mq.matches);
};

const deferScriptLoad = (name, src, onload, requestVisualChange = false) => {
  window.Eurus.loadedScript.add(name);
  
  (events => {
    const loadScript = () => {
      events.forEach(type => window.removeEventListener(type, loadScript));
      clearTimeout(autoloadScript);

      const initScript = () => {
        const script = document.createElement('script');
        script.setAttribute('src', src);
        script.setAttribute('defer', '');
        script.onload = () => {
          document.dispatchEvent(new CustomEvent(name + ' loaded'));
          onload();
        };

        document.head.appendChild(script);
      }

      if (requestVisualChange) {
        if (window.requestIdleCallback) {
          requestIdleCallback(initScript);
        } else {
          requestAnimationFrame(initScript);
        }
      } else {
        initScript();
      }
    };

    let autoloadScript;
    if (Shopify.designMode) {
      loadScript();
    } else {
      const wait = window.innerWidth > 767 ? 2000 : 5000;
      events.forEach(type => window.addEventListener(type, loadScript, {once: true, passive: true}));
      autoloadScript = setTimeout(() => {
        loadScript();
      }, wait);
    }
  })(['touchstart', 'mouseover', 'wheel', 'scroll', 'keydown']);
}

const getSectionInnerHTML = (html, selector = '.shopify-section') => {
  const parsed = new DOMParser().parseFromString(html, 'text/html');
  const element = parsed.querySelector(selector);
  if (!element) {
    return html;
  }
  return element.innerHTML;
}

const xParseJSON = (jsonString) => {
  jsonString = String.raw`${jsonString}`;
  jsonString = jsonString.replaceAll("\\","\\\\").replaceAll('\\"', '\"');
  try {
    return JSON.parse(jsonString);
  } catch (e) {
    console.warn('xParseJSON: failed to parse JSON, returning null', e);
    return null;
  }
}

window.addEventListener("pageshow", () => {
  document.addEventListener('alpine:init', () => {
    if (Alpine.store('xMiniCart')) {
      if (Alpine.store('xMiniCart').needReload) {
        Alpine.store('xMiniCart').reLoad();
      }
      const isCartPage = document.getElementById("main-cart-items");
      if (isCartPage && Alpine.store('xMiniCart').needReload) {
        location.reload();
      }
      Alpine.store('xMiniCart').needReload = true;
    }
  })
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xDarkMode', {
      alias: "btn-theme-mode",
      toggleThemeMode() {
        Alpine.store('xDOM').rePainting = this.alias;
        setTimeout(() => {
          if (document.documentElement.classList.contains('dark')) {
            localStorage.eurus_theme = 0;
            document.documentElement.classList.remove('dark');
          } else {
            localStorage.eurus_theme = 1;
            document.documentElement.classList.add('dark');
          }
          Alpine.store('xHeaderMenu').setTopStickyHeader();
          Alpine.store('pseudoIconTheme').updatePseudoIconInputTheme();

          Alpine.store('xDOM').rePainting = null;
        }, 200); // INP
      },
      toggleLightMode() {
        Alpine.store('xDOM').rePainting = this.alias;
        setTimeout(() => {
          localStorage.eurus_theme = 0;
          document.documentElement.classList.remove('dark');
          Alpine.store('xHeaderMenu').setTopStickyHeader();
          Alpine.store('pseudoIconTheme').updatePseudoIconInputTheme();

          Alpine.store('xDOM').rePainting = null;
        }, 200); // INP
      },
      toggleDarkMode() {
        Alpine.store('xDOM').rePainting = this.alias;
        setTimeout(() => {
          localStorage.eurus_theme = 1;
          document.documentElement.classList.add('dark');
          Alpine.store('xHeaderMenu').setTopStickyHeader();
          Alpine.store('pseudoIconTheme').updatePseudoIconInputTheme();

          Alpine.store('xDOM').rePainting = null;
        }, 200); // INP
      }
    });
    Alpine.store('pseudoIconTheme', {
      init() {
        this.updatePseudoIconInputTheme();
      },
      updatePseudoIconInputTheme() {
        const themeMode = localStorage.getItem('eurus_theme');
        document.querySelectorAll('input[type="date"], input[type="time"]').forEach(input => {
          if (themeMode === '1') {
            input.style.colorScheme = 'dark';
          } else {
            input.removeAttribute('style');
          }
        });
      }      
    });
    Alpine.store('xHelper', {
      toUpdate: [],
      requestControllers: new Map(),
      cancelRequest(key) {
        const controller = this.requestControllers.get(key);
        if (controller) {
          controller.abort();
          this.requestControllers.delete(key);
        }
      },
      formatMoney(amount, formatString) {
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        switch(formatString.match(placeholderRegex)[1]) {
          case 'amount':
            value = this.formatWithDelimiters(amount, 2);
            break;
          case 'amount_no_decimals':
            value = this.formatWithDelimiters(amount, 0);
            break;
          case 'amount_with_comma_separator':
            value = this.formatWithDelimiters(amount, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = this.formatWithDelimiters(amount, 0, '.', ',');
            break;
        }
        return formatString.replace(placeholderRegex, value);
      },
      defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
      },
      formatWithDelimiters(number, precision, thousands, decimal) {
        precision = this.defaultOption(precision, 2);
        thousands = this.defaultOption(thousands, ',');
        decimal   = this.defaultOption(decimal, '.');
    
        if (isNaN(number) || number == null) { return 0; }
        number = (number/100.0).toFixed(precision);
    
        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';
    
        return dollars + cents;
      },
      countdown(configs, callback) {
        const maxAttempt = 100;

        let endDate = new Date(
          configs.end_year,
          configs.end_month - 1,
          configs.end_day,
          configs.end_hour,
          configs.end_minute
        );
        let reset = configs.reset;
        let duration = configs.duration;
        let endTime = endDate.getTime() + (-1 * configs.timezone * 60 - endDate.getTimezoneOffset()) * 60 * 1000;
        
        let startTime;
        if (configs.start_year) {
          let startDate = new Date(
            configs.start_year,
            configs.start_month - 1,
            configs.start_day,
            configs.start_hour,
            configs.start_minute
          );
          startTime = startDate.getTime() + (-1 * configs.timezone * 60 - startDate.getTimezoneOffset()) * 60 * 1000;
          if (reset) {
            endDate = new Date(startTime + duration);
            endTime = endDate.getTime();
          }
        } else {
          if (reset) {
            startTime = endTime;
            endDate = new Date(startTime + duration);
            endTime = endDate.getTime();
          } else {
            startTime = new Date().getTime();
          }
        }

        if (new Date().getTime() < startTime) {
          callback(false, 0, 0, 0, 0);
          return;
        }

        const startInterval = () => {
          let x = setInterval(() => {
            let now = new Date().getTime();
            let distance = 0;

            distance = endTime - now;
            if (distance < 0) {
              clearInterval(x);
              if (reset) {
                let attempt = 0;
                while (distance < 0 && attempt < maxAttempt) {
                  attempt++;
                  if (attempt == 1) {
                    let elapsed = now - startTime;
                    let loopOffset = Math.floor(elapsed / duration) - 1;

                    startTime = startTime + loopOffset * duration;
                  } else {
                    startTime = endTime;
                  }
                  endDate = new Date(startTime + duration);
                  endTime = endDate.getTime();
                  distance = endTime - now;
                }
                if (attempt >= maxAttempt) {
                  callback(false, 0, 0, 0, 0);
                  return;
                }
                startInterval();
              } else {
                callback(false, 0, 0, 0, 0);
                return;
              }
            }
            if (distance > 0) {
              var days = Math.floor(distance / (1000 * 60 * 60 * 24));
              var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
              var seconds = Math.floor((distance % (1000 * 60)) / 1000);

              minutes = minutes < 10 ? '0' + minutes : '' + minutes;
              seconds = seconds < 10 ? '0' + seconds : '' + seconds;

              callback(true, seconds, minutes, hours, days);
            }
          }, 1000);
        }

        startInterval();
      },
      canShow(configs) {
        let endDate = new Date(
          configs.end_year,
          configs.end_month - 1,
          configs.end_day,
          configs.end_hour,
          configs.end_minute
        );
        const endTime = endDate.getTime() + (-1 * configs.timezone * 60 - endDate.getTimezoneOffset()) * 60 * 1000;
        
        let startTime;
        if (configs.start_year) {
          let startDate = new Date(
            configs.start_year,
            configs.start_month - 1,
            configs.start_day,
            configs.start_hour,
            configs.start_minute
          );
          startTime = startDate.getTime() + (-1 * configs.timezone * 60 - startDate.getTimezoneOffset()) * 60 * 1000;
        } else {
          startTime = new Date().getTime();
        }
        let now = new Date().getTime();
        let distance = endTime - now;
        if (distance < 0 || startTime > now) {
          return false;
        } 
        return true;
      },
      handleTime(configs) {
        let endDate = new Date(
          configs.end_year,
          configs.end_month - 1,
          configs.end_day,
          configs.end_hour,
          configs.end_minute
        );
        const endTime = endDate.getTime() + (-1 * configs.timezone * 60 - endDate.getTimezoneOffset()) * 60 * 1000;
        
        let startTime;
        if (configs.start_year) {
          let startDate = new Date(
            configs.start_year,
            configs.start_month - 1,
            configs.start_day,
            configs.start_hour,
            configs.start_minute
          );
          startTime = startDate.getTime() + (-1 * configs.timezone * 60 - startDate.getTimezoneOffset()) * 60 * 1000;
        } else {
          startTime = new Date().getTime();
        }
        let now = new Date().getTime();
        let distance = endTime - now;
        return { "startTime": startTime, "endTime": endTime, "now": now, "distance": distance};
      },
      centerElement(el) {
        let resizeTimeout;
        let currTranslate = 0;
    
        const update = () => {
          window.requestAnimationFrame(() => {
            const rect = el.getBoundingClientRect();
            const translate = rect.left + Math.abs(currTranslate) - (document.documentElement.clientWidth - rect.width) / 2;
            el.style.transform = `translateX(-${translate}px)`;
            currTranslate = translate;
          })
        };
    
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimeout);
          resizeTimeout = setTimeout(update, 150);
        });

        update();
      }
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('xCart', () => ({
      t: '',
      loading: false,
      _getMaxCartQuantity(itemId) {
        const input = document.getElementById(`cart-qty-${itemId}`);
        if (!input) return null;
        const row = input.closest('.cart-item');
        const max = row?.dataset?.maxCartQuantity;
        if (max === undefined || max === '') return null;
        const n = parseInt(max, 10);
        return isNaN(n) ? null : n;
      },
      updateItemQty(itemId, line, inventory_policy, track_inventory, maxQty, extraItemIds) {
        let qty = parseInt(document.getElementById(`cart-qty-${itemId}`).value);
        const maxCartQty = this._getMaxCartQuantity(itemId);
        if (maxCartQty !== null && qty > maxCartQty) {
          qty = maxCartQty;
          document.getElementById(`cart-qty-${itemId}`).value = qty;
        }
        if (this.validateQty(qty)) {
          if (track_inventory || inventory_policy !== "continue") {
            if (qty === 0 && extraItemIds) {
              this._removeExtraItems(itemId, line, qty, extraItemIds);
            } else {
              this._postUpdateItem(itemId, line, qty, maxQty);
            }
          } else {
            if (qty === 0 && extraItemIds) {
              this._removeExtraItems(itemId, line, qty, extraItemIds);
            } else {
              this._postUpdateItem(itemId, line, qty, qty);
            }
          }
        }
      },
      minusItemQty(itemId, line, inventory_policy, track_inventory, maxQty, extraItemIds) {
        let qty = parseInt(document.getElementById(`cart-qty-${itemId}`).value);
        if (this.validateQty(qty)) {
          if (qty > 0) {
            qty -= 1;
            document.getElementById(`cart-qty-${itemId}`).value = qty;
          }

          if (track_inventory || inventory_policy !== "continue") {
            if (qty === 0 && extraItemIds) {
              this._removeExtraItems(itemId, line, qty, extraItemIds);
            } else {
              this._postUpdateItem(itemId, line, qty, maxQty);
            }
          } else {
            if (qty === 0 && extraItemIds) {
              this._removeExtraItems(itemId, line, qty, extraItemIds);
            } else {
              this._postUpdateItem(itemId, line, qty, qty);
            }
          }
        }
      },
      plusItemQty(itemId, line, inventory_policy, track_inventory, maxQty, extraItemIds) {
        const input = document.getElementById(`cart-qty-${itemId}`);
        let qty = parseInt(input.value);
        const maxCartQty = this._getMaxCartQuantity(itemId);
        if (maxCartQty !== null && qty >= maxCartQty) {
          this._addErrorMessage(itemId, (window.Eurus?.cart_quantity_error_html || 'Max quantity per order').replace('[quantity]', String(maxCartQty)));
          return;
        }
        if (this.validateQty(qty)) {
          if (qty >= 0) {
            qty += 1;
            input.value = qty;
          }

          if (track_inventory || inventory_policy !== "continue") {
            this._postUpdateItem(itemId, line, qty, maxQty);
          } else {
            this._postUpdateItem(itemId, line, qty, qty);
          }
        }
      },
      removeItem(itemId, line, extraItemIds, isShippingInsurance) {
        if (extraItemIds) {
          this._removeExtraItems(itemId, line, 0, extraItemIds);
        } else {
          this._postUpdateItem(itemId, line, 0, 0, 500, isShippingInsurance);
        }
      },
      handleKeydown(evt, el) {
        if (evt.key !== 'Enter') return;
        evt.preventDefault();
        el.blur();
        el.focus();
      },
      _removeExtraItems(itemId, line, qty, extraItemIds, wait = 500) {
        clearTimeout(this.t);

        const func = async () => {
          this.loading = true;
          await Alpine.store('xCartHelper').waitForEstimateUpdate();
          window.updatingEstimate = true;

          let removeEl = document.getElementById(`remove-${itemId}`);
          let removeElMobile = document.getElementById(`remove-mobile-${itemId}`);
          if(removeEl){
            removeEl.style.display = 'none';
          }
          if(removeElMobile){
            removeElMobile.style.display = 'none';
          }
          document.getElementById(`loading-${itemId}`)?.classList?.remove('hidden');
          document.getElementById(`loading-mobile-${itemId}`)?.classList?.remove('hidden');
          const sectionArray = Alpine.store('xCartHelper').getSectionsToRender();
          const sections = sectionArray.map(s => s.id);
          let data = { [itemId]: qty };
          extraItemIds.split(',').forEach(id => {
            if (id) {
              data[id] = 0;
            }
          });
          let updateData = {
            updates: data,
            'sections': sections,
            'sections_url': window.location.pathname
          };

          fetch(`${Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(updateData)
          })
          .then(response => {
            return response.json()
          })
          .then(async (parsedState) => {
            if (parsedState.status == '422') {
              this._addErrorMessage(itemId, parsedState.message);
              this.updateCart(line);
            } else {
              const finalState = await Alpine.store('freeGiftCta')
                ?.enforceGiftEligibility?.(parsedState, sections) ?? parsedState;
              this.updateCartUI(finalState, sectionArray, itemId, line, qty);
            }
          })
          .finally(() => {
            Alpine.store('xCartHelper').updateEstimateShippingFull();
          });
        }

        this.t = setTimeout(() => {
          func();
        }, wait);
      },
      _postUpdateItem(itemId, line, qty, maxQty, wait = 500, isShippingInsurance) {
        if (isShippingInsurance) {
          Alpine.store('xPopupInsurance').loading = true;
        };
        clearTimeout(this.t);

        const func = async () => {
          this.loading = true;
          await Alpine.store('xCartHelper').waitForEstimateUpdate();
          window.updatingEstimate = true;

          let removeEl = document.getElementById(`remove-${itemId}`);
          let removeElMobile = document.getElementById(`remove-mobile-${itemId}`);
          if(removeEl){
            removeEl.style.display = 'none';
          }
          if(removeElMobile){
            removeElMobile.style.display = 'none';
          }
          document.getElementById(`loading-${itemId}`)?.classList?.remove('hidden');
          document.getElementById(`loading-mobile-${itemId}`)?.classList?.remove('hidden');
          const sectionArray = Alpine.store('xCartHelper').getSectionsToRender();
          const sections = sectionArray.map(s => s.id);
          let updateData = {
            'id': itemId,
            'quantity': `${qty}`,
            'sections': sections,
            'sections_url': window.location.pathname
          };

          let productIds = [];

          fetch(`${Shopify.routes.root}cart/change.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(updateData)
          })
          .then(response => {
            return response.json()
          })
          .then(async (parsedState) => {
            if (parsedState.status == '422') {
              this._addErrorMessage(itemId, parsedState.message);
              this.updateCart(line, itemId);
            } else {
              const finalState = await Alpine.store('freeGiftCta')
                ?.enforceGiftEligibility?.(parsedState, sections) ?? parsedState;
              finalState.items.forEach(item => { productIds.push(item.product_id) });
              this.updateCartUI(finalState, sectionArray, itemId, line, qty);
            }
          })
          .finally(() => {
            Alpine.store('xCartHelper').updateEstimateShippingFull();
            productIds.forEach(id => { document.dispatchEvent(new CustomEvent(`eurus:product-card:clear:${id}`)); })

            // Dispatch the general cart items changed event
            if (productIds.length > 0) {
              document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
            }
            if (isShippingInsurance) {
              Alpine.store('xPopupInsurance').loading = false;
            };
          });
        }

        this.t = setTimeout(() => {
          func();
        }, wait);
      },
      updateCartUI(parsedState, sectionArray, itemId, line, qty) {
        const items = document.querySelectorAll('.cart-item');
        if (parsedState.errors) {
          this._addErrorMessage(itemId, parsedState.errors);
          return;
        }
        Alpine.store('xCartHelper').currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span').innerHTML);
        Alpine.store('xCartHelper').swapSections(parsedState.sections);

        const currentItemCount = Alpine.store('xCartHelper').currentItemCount
        Alpine.store('xCartHelper').currentItemCount = parsedState.item_count;
        if (currentItemCount != parsedState.item_count) {
          document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
        }

        const lineItemError = document.getElementById(`LineItemError-${itemId}`);
        if (lineItemError) {lineItemError.classList.add('hidden');}
        
        const updatedLine = parsedState.items.find((item) => item.key === itemId);
        const updatedValue = updatedLine ? updatedLine.quantity : undefined;
        
        if (items.length === parsedState.items.length && updatedValue !== parseInt(qty)) {
          let message = '';
          if (typeof updatedValue === 'undefined') {
            message = window.Eurus.cart_error;
          } else {
            message = window.Eurus.cart_quantity_error_html.replace('[quantity]', updatedValue);
          }
          this._addErrorMessage(itemId, message);
        }
        let loadingEl = document.getElementById(`loading-${itemId}`);
        let loadingElMobile = document.getElementById(`loading-mobile-${itemId}`);
        let removeEl = document.getElementById(`remove-${itemId}`);
        let removeElMobile = document.getElementById(`remove-mobile-${itemId}`);
        if(removeEl){
          removeEl.style.display = 'block';
        }
        if(removeElMobile){
          removeElMobile.style.display = 'flex';
        }
        if (loadingEl) {
          loadingEl.classList.add('hidden');
        }
        if (loadingElMobile) {
          loadingElMobile.classList.add('hidden');
        }
        this.loading = false;
      },
      updateCart(line, itemId) {
        let url = ''
        if (window.location.pathname !== '/cart'){
          url = `${window.location.pathname}?section_id=cart-drawer`
        } else {
          url = `${window.location.pathname}`
        }
        fetch(url)
        .then(reponse => {
          return reponse.text();
        })
        .then(response => {
          const parser = new DOMParser();
          const html = parser.parseFromString(response,'text/html');
          
          const rpCartFooter = html.getElementById('main-cart-footer');
          const cartFooter = document.getElementById('main-cart-footer');
          if (rpCartFooter && cartFooter) {
            cartFooter.innerHTML = rpCartFooter.innerHTML;
          }
          const rpItemInput = html.querySelector('.cart-item-qty-' + line);
          const itemInput = document.querySelector('.cart-item-qty-' + line);
          if (rpItemInput && itemInput) {
            itemInput.value = rpItemInput.value;
          }
          const rpItemTotal = html.querySelector('.cart-item-price-' + line);
          const itemTotal = document.querySelector('.cart-item-price-' + line);
          if (itemTotal && rpItemTotal) {
            itemTotal.innerHTML = rpItemTotal.innerHTML;
          }
          const rpPriceTotal = html.querySelector('.cart-drawer-price-total');
          const priceTotal = document.querySelector('.cart-drawer-price-total');
          if (rpPriceTotal && priceTotal) {
            priceTotal.innerHTML = rpPriceTotal.innerHTML;
          }
          const rpCartIcon = html.querySelector('cart-icon-bubble');
          const cartIcon = document.querySelector('cart-icon-bubble');
          if (cartIcon && rpCartIcon) {
            cartIcon.innerHTML = rpCartIcon.innerHTML;
          }
        }).finally(() => {
          let loadingEl = document.getElementById(`loading-${itemId}`);
          let loadingElMobile = document.getElementById(`loading-mobile-${itemId}`);
          if (loadingEl) {
            loadingEl.classList.add('hidden');
          }
          if (loadingElMobile) {
            loadingElMobile.classList.add('hidden');
          }
          this.loading = false;
        });
      },
      clearCart(itemId) {
        let removeEl = document.getElementById(`remove-${itemId}`);
        let removeElMobile = document.getElementById(`remove-mobile-${itemId}`);
        if(removeEl){
          removeEl.style.display = 'none';
        }
        if(removeElMobile){
          removeElMobile.style.display = 'none';
        }
        document.getElementById(`loading-${itemId}`)?.classList?.remove('hidden');
        document.getElementById(`loading-mobile-${itemId}`)?.classList?.remove('hidden');

        fetch(window.Shopify.routes.root + 'cart/clear.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body:  JSON.stringify({ "sections":  Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id) })
        }).then((response) => {
          return response.json();
        }).then((response) => {
          requestAnimationFrame(() => {
            setTimeout(() => {
              Alpine.store('xCartHelper').swapSections(response.sections);
              Alpine.store('xCartHelper').currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span').innerHTML);
              document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
            }, 0)
          });
        })
        .catch((error) => {
          console.error('Error:', error);
        }).finally(() => {
          document.cookie = `eurus_insurance=; path=/`;
        })
      },
      async addShippingInsurance(productId) {
        Alpine.store('xPopupInsurance').loading = true;
        Alpine.store('xPopupInsurance').openInsuranceNoti = false;
        let item = [{
          id: productId,
          quantity: 1
        }];
        await Alpine.store('xCartHelper').waitForEstimateUpdate();
        window.updatingEstimate = true;

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body:  JSON.stringify({ "items": item, "sections":  Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id) })
        }).then((response) => {
          return response.json();
        }).then((response) => {
          Alpine.store('xCartHelper').swapSections(response.sections);
          Alpine.store('xCartHelper').currentItemCount = parseInt(document.querySelector('#cart-icon-bubble span').innerHTML);
        })
        .catch((error) => {
          console.error('Error:', error);
        }).finally(() => {
          Alpine.store('xCartHelper').updateEstimateShippingFull();
          document.cookie = `eurus_insurance=${productId}; path=/`;
          Alpine.store('xPopupInsurance').loading = false;
          Alpine.store('xPopupInsurance').openInsuranceNotification()
        })
      },
      updateEstimateShipping(el, line, itemId, cutOffHour, cutOffMinute, hour, minutes, shippingInsuranceId, cartSize) {
        if (shippingInsuranceId === itemId) return;
        const queryString = window.location.search;
        if (queryString.includes("share_cart:true") && !Alpine.store('xCartShare').shared) {
          return;
        }
        let properties = xParseJSON(el.getAttribute("x-data-properties"));
        //update cut-off time for checkout page
        for (let key in properties) {
          if (properties[key] && properties[key].includes('time_to_cut_off')) {
            if (Alpine.store('xEstimateDelivery').noti == '')
              Alpine.store('xEstimateDelivery').countdownCutOffTime(cutOffHour, cutOffMinute, hour, minutes);
            properties[key] = properties[key].replace('time_to_cut_off', Alpine.store('xEstimateDelivery').noti);
          }
        };
      },
      async updateDate(date) {
        await Alpine.store('xCartHelper').waitForEstimateUpdate();
        var formData = {
          'attributes': {
            'datetime-updated': `${date}`           
          }
        }; 
        fetch(Shopify.routes.root+'cart/update', {
          method:'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(formData)
        })
      },
      _addErrorMessage(itemId, message) {
        const lineItemError = document.getElementById(`LineItemError-${itemId}`);
        if (!lineItemError) return;
        lineItemError.classList.remove('hidden');
        lineItemError
          .getElementsByClassName('cart-item__error-text')[0]
          .innerHTML = message;
      },
      validateQty: function(number) {
        if((parseFloat(number) != parseInt(number)) && isNaN(number)) {
          return false
        }

        return true;
      }
    }));

    let lastCartFocus = null;
    document.addEventListener('focusin', (event) => {
      if (event.target.closest && event.target.closest('#CartDrawer, #main-cart-items, #main-cart-footer')) {
        lastCartFocus = event.target;
      }
    });

    Alpine.store('xCartHelper', {
      currentItemCount: 0,
      validated: true,
      waitingForGiftBox: false,
      openField: '',
      openDiscountField: '',
      needUpdateEstimated: false,
      updateCart: async function(data, needValidate = false) {
        await Alpine.store('xCartHelper').waitForEstimateUpdate();
        const formData = JSON.stringify(data);
        return fetch(Shopify.routes.root + 'cart/update', {
          method:'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: formData
        }).then((response) => {
          if (needValidate) this.validateCart();
          return response.json();
        });
      },
      cartValidationRequest() {
        this.validateCart();
        Alpine.store('xMiniCart').openCart();
      },
      validateCart: function(isCheckOut = false) {
        this.validated = true;

        document.dispatchEvent(
          new CustomEvent('eurus:cart:validate', {
            detail: {
              isCheckOut: isCheckOut,
            },
          })
        );
      },
      async goToCheckout(e) {
        e.preventDefault();

        if (this.waitingForGiftBox) return;

        await this.waitForEstimateUpdate();

        // Leaving the page cancels an in-flight gift box add, so let it land first (MFS-651).
        const giftBoxCheckout = Alpine.store('xGiftBoxCheckout');
        if (giftBoxCheckout?.hasPendingUpdates()) {
          this.waitingForGiftBox = true;
          try {
            await giftBoxCheckout.waitForPendingUpdates();
          } finally {
            this.waitingForGiftBox = false;
          }
        }

        try {
          const cart = await window.CartState.get({ force: true });
          document.dispatchEvent(
            new CustomEvent('eurus:cart:pre-checkout-validate', { detail: { cart } })
          );
        } catch (error) {
          console.error('[Cart] Error loading cart before checkout:', error);
        }

        this.validateCart(true);

        if (!this.validated) {
          Alpine.store('xGiftBoxCheckout')?.syncDom();
          const checkoutButton =
            document.getElementById('checkout-submit') ||
            document.getElementById('checkout-submit-mobile');
          checkoutButton?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        Alpine.store('xGiftBoxCheckout')?.hide();

        const noteField = document.getElementById('x-cart-note') || document.getElementById('x-cart-note-mobile');
        const noteValue = noteField ? noteField.value.trim() : '';

        let formData = {
          'attributes': {
            'collection-pagination': null,
            'blog-pagination': null,
            'choose_option_id': null,
            'datetime-updated': null
          }
        };

        if (noteValue) {
          formData.note = noteValue;
        }

        await fetch(Shopify.routes.root+'cart/update', {
          method:'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(formData)
        });

        window.location.href = Shopify.routes.root + 'checkout';
      },
      waitForEstimateUpdate() {
        return new Promise(resolve => {
          function check() {
            if (!window.updatingEstimate) {
              resolve();
            } else {
              requestAnimationFrame(check);
            }
          }
          check();
        });
      },
      estimateRefresh: null,
      estimateRefreshQueued: false,
      updateEstimateShippingFull() {
        // Only one clear + re-add may run at a time. Callers that skip the updatingEstimate
        // lock (or a second tab) used to start a parallel refresh and double every line.
        if (this.estimateRefresh) {
          this.estimateRefreshQueued = true;
          return this.estimateRefresh;
        }
        window.updatingEstimate = true;
        const run = () => this._runEstimateRefresh();
        // Web Locks serialize the refresh across tabs sharing this cart; the in-page
        // mutex above cannot see another tab's clear + re-add.
        const refresh = navigator.locks ? navigator.locks.request('estimate-shipping-refresh', run) : run();
        this.estimateRefresh = refresh
          .catch(console.error)
          .finally(() => {
            this.estimateRefresh = null;
            if (this.estimateRefreshQueued) {
              this.estimateRefreshQueued = false;
              return this.updateEstimateShippingFull();
            }
            window.updatingEstimate = false;
          });
        return this.estimateRefresh;
      },
      async _runEstimateRefresh() {
        if (!this.needUpdateEstimated) return;
        const queryString = window.location.search;
        if (queryString.includes("share_cart:true") && !Alpine.store('xCartShare').shared) return;

        const cart = await window.CartState.get({ force: true });
        if (cart.item_count == 0) return;

        let removeUpdates = {};
        let reAddItems = [];

        cart.items.forEach((item) => {
          const originalProps = item.properties || {};
          const newProps = { ...originalProps };

          // Custom logic to update time_to_cut_off
          let cartItemEl = document.querySelector(`.cart-item[x-data-key="${item.key}"]`);
          if (cartItemEl) {
            let properties = xParseJSON(cartItemEl.getAttribute("x-data-properties"));
            for (let key in properties) {
              if (properties[key] && properties[key].includes('time_to_cut_off')) {
                newProps[key] = properties[key].replace('time_to_cut_off', Alpine.store('xEstimateDelivery').noti);
              }
            }
          }

          removeUpdates[item.key] = 0;

          reAddItems.push({
            id: item.variant_id,
            quantity: item.quantity,
            properties: newProps,
            selling_plan: item.selling_plan_allocation?.selling_plan.id || undefined
          });
        });

        const cleared = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: removeUpdates })
        });
        // A failed clear means the lines are already gone (another context cleared them);
        // re-adding on top would duplicate them.
        if (!cleared.ok) return;

        const added = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: reAddItems.reverse(),
            sections: Alpine.store('xCartHelper').getSectionsToRender().map((section) => section.id)
          })
        });
        if (!added.ok) return;
        const res = await added.json();
        Alpine.store('xCartHelper').swapSections(res.sections);
      },
      getSectionsToRender() {
        const cartItemEl = document.getElementById('main-cart-items');
        if (cartItemEl) {
          const templateId = cartItemEl.closest('.shopify-section').id
                              .replace('cart-items', '')
                              .replace('shopify-section-', '');

          return [
            {
              id: templateId + 'cart-items',
              selector: '#main-cart-items'
            },
            {
              id: templateId + 'cart-footer',
              selector: '#main-cart-footer'
            },
            {
              id: templateId + 'cart-upsell',
              selector: '#main-cart-upsell'
            },
            {
              id: "cart-icon-bubble",
              selector: '#cart-icon-bubble'
            },
            {
              id: 'mobile-cart-icon-bubble',
              selector: '#mobile-cart-icon-bubble'
            }
          ];
        }

        return [
          {
            id: "cart-icon-bubble",
            selector: '#cart-icon-bubble'
          },
          {
            id: 'mobile-cart-icon-bubble',
            selector: '#mobile-cart-icon-bubble'
          },
          {
            id: 'cart-drawer',
            selector: '#CartDrawer'
          }
        ];
      },
      /**
       * Swap cart sections in-place from a Section Rendering API response.
       * Accepts either a flat { 'section-id': '<html>' } map or response.sections.
       * Preserves the Nosto personalised-cards grid and its dropdown's open state
       * across the swap (the Nosto element lives inside #main-cart-items and would
       * otherwise be wiped by the innerHTML replacement).
       */
      swapSections(sections) {
        if (!sections) return;

        // The "Personalised Cards" dropdown can be sourced from Nosto
        // (#personalised-cards-nosto, injected client-side and wiped by the swap,
        // so it needs snapshot/restore) or from Shopify (the
        // #personalised-cards-shopify-* grid, server-rendered inside the swapped
        // section HTML, so it survives on its own). Either way, preserve the
        // dropdown's open state across the swap.
        const nostoEl = document.querySelector('#personalised-cards-nosto');
        const cardsEl = nostoEl || document.querySelector('[id^="personalised-cards-shopify-"]');
        const cardsDropdown = cardsEl?.closest('[x-data]');
        let cardsDropdownWasOpen = false;
        let nostoSnapshotHTML = '';
        if (cardsDropdown) {
          try { cardsDropdownWasOpen = Alpine.$data(cardsDropdown)?.open === true; } catch (e) {}
        }
        if (nostoEl && nostoEl.innerHTML.trim()) {
          nostoSnapshotHTML = nostoEl.innerHTML;
        }
        const focusSnapshot = this.captureCartFocus();

        this.getSectionsToRender().forEach((section) => {
          section.selector.split(',').forEach((selector) => {
            const el = document.querySelector(selector);
            if (el && sections[section.id]) {
              const html = getSectionInnerHTML(sections[section.id], selector);
              if (html) el.innerHTML = html;
            }
          });
        });

        this.restoreCartFocus(focusSnapshot);

        requestAnimationFrame(() => {
          this.restoreNostoGrid(nostoEl, nostoSnapshotHTML);
          if (cardsDropdownWasOpen) this.reopenCardsDropdown();
          // Let the personalised-cards fallback re-arm against the freshly
          // swapped-in template (quantity changes etc. don't fire cart:refresh).
          document.dispatchEvent(new CustomEvent('cart:sections:swapped'));
        });
      },

      captureCartFocus() {
        const el = lastCartFocus;
        if (!el || !el.isConnected) return null;
        const active = document.activeElement;
        if (active && active !== document.body && active !== el) return null;

        const selectors = this.getSectionsToRender().map((section) => section.selector).join(',');
        const scope = el.closest(selectors);
        if (!scope || !scope.id) return null;

        const row = el.closest('[data-cart-line-variant]');
        if (!row) return el.id ? { scope: scope.id, id: el.id } : null;

        const focusable = Alpine.store('xFocusElement').focusableElements;
        const variant = row.dataset.cartLineVariant;
        return {
          scope: scope.id,
          variant,
          occurrence: Array.from(scope.querySelectorAll(`[data-cart-line-variant="${variant}"]`)).indexOf(row),
          position: Array.from(scope.querySelectorAll('[data-cart-line-variant]')).indexOf(row),
          control: Array.from(row.querySelectorAll(focusable)).indexOf(el)
        };
      },

      restoreCartFocus(snapshot) {
        if (!snapshot) return;
        const active = document.activeElement;
        if (active && active !== document.body && active.isConnected) return;

        const scope = document.getElementById(snapshot.scope);
        if (!scope) return;

        const focusElement = Alpine.store('xFocusElement');
        let target = null;
        if (snapshot.id) {
          target = document.getElementById(snapshot.id);
        } else {
          const rows = scope.querySelectorAll(`[data-cart-line-variant="${snapshot.variant}"]`);
          const allRows = scope.querySelectorAll('[data-cart-line-variant]');
          const row = rows[snapshot.occurrence]
            || (rows.length === 1 ? rows[0] : null)
            || allRows[Math.min(snapshot.position, allRows.length - 1)];
          if (row) target = row.querySelectorAll(focusElement.focusableElements)[snapshot.control];
          if (!target && !allRows.length) target = scope.querySelector('[role="dialog"]');
        }

        if (target && scope.contains(target) && focusElement.isRendered(target)) {
          target.focus({ preventScroll: true });
        }
      },

      // Restore the Nosto personalised-cards grid after a section swap. Nosto
      // injects its grid client-side, so the innerHTML swap wipes it: re-apply the
      // pre-swap snapshot, or ask Nosto to reload if the placement came back empty.
      // Shopify-sourced cards are server-rendered with the section and need nothing.
      restoreNostoGrid(prevNostoEl, snapshotHTML) {
        const nostoEl = document.querySelector('#personalised-cards-nosto');
        if (!nostoEl) return;
        if (nostoEl !== prevNostoEl && snapshotHTML) {
          nostoEl.innerHTML = snapshotHTML;
        } else if (!nostoEl.innerHTML.trim() && window.nostojs) {
          window.nostojs((api) => api.loadRecommendations());
        }
      },

      // Re-open the personalised-cards dropdown if it was open before the swap;
      // the swapped-in markup resets Alpine state to closed. There is a single
      // apps_dropdown block (schema "limit": 1), so in Nosto-fallback mode the Nosto
      // element and the hidden Shopify grid live inside the SAME dropdown - either
      // resolves to it via closest(). Prefer the Nosto element to mirror the
      // pre-swap capture in swapSections() rather than relying on DOM order.
      reopenCardsDropdown() {
        const cardsEl = document.querySelector('#personalised-cards-nosto')
          || document.querySelector('[id^="personalised-cards-shopify-"]');
        const dropdown = cardsEl?.closest('[x-data]');
        if (!dropdown) return;
        try { Alpine.$data(dropdown).open = true; } catch (e) {}
      }
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('xModalSearch', (type, desktopMaximunResults, mobileMaximunResults, productTypeSelected) => ({
      t: '',
      result: ``,
      query: '',
      cachedResults: [],
      openResults: false,
      productTypeSelected: productTypeSelected,
      showSuggest: false,
      loading: false,
      open() {
        this.$refs.open_search.classList.remove("popup-hidden");
        const input_search = document.getElementById('search-in-modal');
        if (input_search) {
          setTimeout(() => {  
          }, 100);
        }
      },
      close() {
        this.$refs.open_search.classList.add("popup-hidden");
      },
      keyUp() {
        this.query = this.$el.value;
        return () => {
          clearTimeout(this.t);
          this.t = setTimeout(() => {
            if (this.query != "") {
              this.showSuggest = false;
              this.getSearchResult(this.query);
            } else {
              this.showSuggest = true;
              this.result = "";
            }
          }, 300);
        };
      },
      getSearchResult(query) {
        this.openResults = true;
        const limit = window.innerWidth > 767 ? desktopMaximunResults : mobileMaximunResults;
        let q = this.productTypeSelected != productTypeSelected ? `${this.productTypeSelected} AND ${query}` : query;

        const queryKey = q.replace(" ", "-").toLowerCase() + '_' + limit;

        if (this.cachedResults[queryKey]) {
          this.result = this.cachedResults[queryKey];
          return;
        }

        this.loading = true;
        const field = "author,body,product_type,tag,title,variants.barcode,variants.sku,variants.title,vendor"
        fetch(`${Shopify.routes.root}search/suggest?q=${encodeURIComponent(q)}&${encodeURIComponent('resources[type]')}=${encodeURIComponent(type)}&${encodeURIComponent('resources[options][fields]')}=${encodeURIComponent(field)}&${encodeURIComponent('resources[limit]')}=${encodeURIComponent(limit)}&section_id=predictive-search`)
          .then((response) => {
            return response.text();
          })
          .then((response) => {
            const parser = new DOMParser();
            const text = parser.parseFromString(response, 'text/html');
            this.result = text.querySelector("#shopify-section-predictive-search").innerHTML;
            this.cachedResults[queryKey] = this.result;
          })
          .catch((error) => {
            throw error;
          });
        this.loading = false;
      },
      setProductType(value, input) {
        this.productTypeSelected = value;
        document.getElementById(input).value = value;
        if(this.query != '') {
          this.getSearchResult(this.query);
        }
      },
      focusForm() {
        if (this.$el.value != '') {
          this.showSuggest = false;
        } else {
          this.showSuggest = true;
        }
      }
    }));
  });
});

requestAnimationFrame(() => {
  // Kept outside the store so reading them inside Alpine effects never subscribes them to it.
  let headerAnimatingUntil = 0;
  let expandedHeaderHeight = 0;
  let headerHeightLost = 0;
  let onHeaderTransition;
  document.addEventListener('alpine:init', () => {
    Alpine.store('xHeaderMenu', {
      isSticky: false,
      resizeObserverPaused: false,
      stickyCalulating: false,
      openHamburgerMenu: false,
      isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false,
      sectionId: '',
      stickyType: 'none',
      lastScrollTop: 0,
      themeModeChanged: false,
      showLogoTransparent: true,
      offsetTop: 0,
      clickedHeader: false,
      mobileHeaderLayout: '',
      overlay: false,
      skipFocusOpen: false,
      scrollDir: '',
      isTransparent: false,
      renderAjax(el, id, element) {
        fetch(
          `${window.location.pathname}?sections=${id}`
        ).then(response => response.json())
        .then(response => {
          let html = getSectionInnerHTML(response[id], element);
          if (el?.closest('[data-breakpoint="tablet"]')) {
            html = html?.replace('id="search-in-modal"', 'id="search-in-modal-mobile"');
          }
          el.innerHTML = html;
        })
      },
      setPosition(el,level, hamburger=false) {
        let spacing = 0;
        if (!hamburger) {
          level = level - 1;
        } else {
          level = level - 0.5;
        }
        requestAnimationFrame(() => {
          const elm = el.closest(".tree-menu");
          const widthEl = elm.getElementsByClassName("toggle-menu")[0];
          const elRect = elm.getBoundingClientRect();
          var left = (elRect.left - (widthEl.offsetWidth*level)) < 0;
          var right = (elRect.right + (widthEl.offsetWidth*level)) > (window.innerWidth || document.documentElement.clientWidth);
          if (document.querySelector('body').classList.contains('rtl')) {
            if (left) {
              el.classList.add('right-0');
              widthEl.classList.add('left-0');
              elm.classList.remove('position-left');
            } else {
              el.classList.add('left-0');
              widthEl.classList.add('right-0');
              elm.classList.add('position-left');
            }
          } else { 
            if (right) {
              el.classList.add('left-0');
              widthEl.classList.add('right-0');
              elm.classList.add('position-left');
            } else {
              el.classList.add('right-0');
              widthEl.classList.add('left-0');
              elm.classList.remove('position-left');
            }
          }  
        });
      },
      resizeWindow(el,level, hamburger=false) {
        const debounce = (func, wait) => {
          let timeout;
          return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
          };
        };

        const onResize = debounce(() => {
          this.setPosition(el, level, hamburger);
        }, 100);

        addEventListener("resize", onResize);
      },
      selectItem(el, isSub = false) {
        el.style.setProperty('--header-container-height', document.getElementById("x-header-container").offsetHeight + 'px')
        if(this.isTransparent){
          el.style.setProperty('--header-container-height', document.getElementById("sticky-header-content").offsetHeight + 'px')
        }
        if (el.closest(".toggle-menu")) {
          el.style.setProperty('--mega-menu-height', el.offsetTop + el.clientHeight + 'px') 
        }
        this.setAnimationMenu(el, isSub);
        const itemSelector = isSub ? '.toggle-menu-sub' : '.toggle-menu';

        var items = isSub ? el.closest('.toggle-menu').querySelectorAll(itemSelector) : document.querySelectorAll(itemSelector);

        if (isSub) {
          var subMenuLinks = el.parentElement.querySelectorAll(".sub-menu-item");
          for (var i = 0; i < subMenuLinks.length; i++) {
            subMenuLinks[i].classList.remove("is-active");
          }
          el.classList.add("is-active");
        }

        for (var i = 0; i < items.length; i++) {
          if (isSub) {
            items[i].classList.remove('open');
            items[i].classList.add('toggle-menu-sub-hidden');
          } else {
            items[i].classList.add('toggle-menu-hidden');
            items[i].querySelector('.toggle-menu-sub.open')?.classList.add('toggle-menu-sub-hidden');
          }
        }

        let toggleMenu = el.querySelector(itemSelector);

        if (toggleMenu) {
          if (isSub) {
            if (el.closest('.toggle-menu').classList.contains("mega-menu-vertical")) {
              toggleMenu.classList.add('open');
            }
            toggleMenu.classList.remove('toggle-menu-sub-hidden');
          } else {
            toggleMenu.classList.remove('toggle-menu-hidden');
            el.querySelector('.toggle-menu-sub.open')?.classList.remove('toggle-menu-sub-hidden');
          }
        }
        this.toggleOverlay();
      },
      toggleOverlay() {
        let countMenu = document.querySelectorAll('.toggle-menu');
        let countMenuHidden = document.querySelectorAll('.toggle-menu-hidden');
        if (countMenu.length == countMenuHidden.length) {
          this.overlay = false;
        } else {
          this.overlay = true;
        }
        this.syncMenuState();
      },
      syncMenuState() {
        document.querySelectorAll('[data-menu-trigger]').forEach((trigger) => {
          const menu = trigger.closest('.has-dropdown')?.querySelector('.toggle-menu');
          const open = !!menu && !menu.classList.contains('toggle-menu-hidden');
          trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (menu) menu.inert = !open;
        });
      },
      focusItem(el) {
        if (!this.skipFocusOpen) this.selectItem(el);
      },
      leaveItem(el, e) {
        if (el.contains(e.relatedTarget) || el.matches(':hover')) return;
        this.hideMenu(el);
      },
      closeOnEscape() {
        const trigger = document.activeElement?.closest('.has-dropdown')?.querySelector('[data-menu-trigger]');
        if (trigger && trigger !== document.activeElement) {
          this.skipFocusOpen = true;
          trigger.focus();
          this.skipFocusOpen = false;
        }
        this.hideMenu();
      },
      hideMenu(el, isSub = false) {
        var items = isSub ? document.querySelectorAll('.toggle-menu-sub') : document.querySelectorAll('.toggle-menu');
        if (!isSub) {
          const itemClicked =  document.querySelector('.clicked');
          if (itemClicked) { itemClicked.classList.remove("clicked") }
        } else {
          var subMenuLinks = el.parentElement.querySelectorAll(".sub-menu-item");
          for (var i = 0; i < subMenuLinks.length; i++) {
            subMenuLinks[i].classList.remove("is-active");
          }
        }
        for (var i = 0; i < items.length; i++) {  
          if (isSub) {
            items[i].classList.add('toggle-menu-sub-hidden');
          } else {
            items[i].classList.add('toggle-menu-hidden');
            items[i].querySelector('.toggle-menu-sub.open')?.classList.add('toggle-menu-sub-hidden');
          }
        }
        this.toggleOverlay();
        this.isMenuOpen = false;
      },
      hideMenuHorizontal(el) {
        if (!el.querySelector(".toggle-menu-sub")) return;
        if (el.querySelector(".toggle-menu-sub").classList.contains('toggle-menu-sub-hidden')) return;
        el.querySelector('.click-sub')?.classList.remove('click-sub');
        this.hideMenu(el, true);
      },
      // start handle touch menu on the ipad
      touchItem(el, isSub = false) {
        const touchClass = isSub ? 'touched-sub' : 'touched';

        el.addEventListener("touchend", (e) => {
          if (el.classList.contains(touchClass)) {
            window.location.replace(el.getAttribute('href'));
          } else {
            e.preventDefault(); 
            var dropdown = document.querySelectorAll(`.${touchClass}`);
            for (var i = 0; i < dropdown.length; i++) { 
              dropdown[i].classList.remove(touchClass); 
            }

            el.classList.add(touchClass);
            this.selectItem(el.closest('.has-dropdown'), isSub);
          }
        });
      },
      clickItem(el, e, isSub = false, isMenu, open_new_window = false) {
        const clickClass = isSub ? 'click-sub' : 'clicked';
        e.preventDefault(); 
        if (el.classList.contains(clickClass)) {
          this.hideMenu();
        } else {
          this.isMenuOpen = true;
          var dropdown = document.querySelectorAll(`.${clickClass}`);
          for (var i = 0; i < dropdown.length; i++) { 
            dropdown[i].classList.remove(clickClass); 
          }
          el.classList.add(clickClass);
          if (!isMenu) {
            this.selectItem(el.closest('.has-dropdown'), isSub);
          }
        }
      },

      // handle sticky header
      initSticky(el, sectionId, stickyType, transparent) {
        this.isTransparent = transparent;
        this.sectionId = sectionId;
        this.stickyType = stickyType;
        this.offsetTop = el.offsetTop;
        this.syncVariableHeightHeader();
        window.addEventListener('resize', () => {
          if(!transparent){
            el.style.height = document.getElementById("sticky-header").offsetHeight + 'px';
          }
          this.syncVariableHeightHeader();
          this.setPositionTop();
        });
        // Header and promo banner heights settle after resize (logo transition, breakpoint styles), so re-sync once they do.
        this.heightObserver?.disconnect();
        this.heightObserver = new ResizeObserver(() => this.syncVariableHeightHeader());
        [document.getElementById("sticky-header"), document.querySelector(".section-promo-banner")]
          .forEach(target => target && this.heightObserver.observe(target));
        // A shared handler, so the theme editor re-running initSticky on the same element does not stack listeners.
        onHeaderTransition ??= (event) => {
          if (this.isPinnedHeader() && /^(width|padding-top|row-gap|margin)/.test(event.propertyName)) this.followHeaderAnimation();
        };
        document.getElementById("sticky-header").addEventListener('transitionrun', onHeaderTransition);
        this.setPositionTop();
        el.style.height = document.getElementById("sticky-header").offsetHeight + 'px';
        document.documentElement.style.setProperty('--header-h', el.offsetHeight + 'px');
        new ResizeObserver((entries) => {
          if (Alpine.store('xHeaderMenu').resizeObserverPaused) return;
          if (Alpine.store('xMobileNav').show) return;
          if (this.isHeaderAnimating()) return;
          for (const entry of entries) {
            document.documentElement.style.setProperty('--header-h', entry.target.offsetHeight + 'px');
          }
        }).observe(el);
      },
      setPositionTop() {
        let top_height = 0;
        let announcement_height = 0;
        let header_height = 0;
        const announcement = document.querySelector("#x-announcement");
        const header = document.querySelector("#x-header-container");
        const sectionAnnouncement = document.querySelector(".section-announcement");
        const stickyHeader = document.querySelector("#sticky-header");
        this.setTopStickyHeader();
        if (announcement && announcement.dataset.isSticky == 'true') {
          announcement_height = announcement.offsetHeight;
          header.style.setProperty('--announcement-height', announcement_height + "px");
          sectionAnnouncement.style.zIndex = 55;
          sectionAnnouncement.style.top = "0px";
        }
        if (header.dataset.isSticky == 'true') {
          header_height = stickyHeader.offsetHeight;
        }
        const banner_height = this.stickyBannerAboveHeader();
        if (this.isPinnedHeader()) {
          // The pinned header sticks as a whole section, so it is the section that clears a sticky announcement above it.
          const announcementAbove = document.querySelectorAll(".section-announcement ~ .section-header").length > 0;
          document.getElementById(this.sectionId).style.top = (announcementAbove ? announcement_height : 0) + banner_height + "px";
          stickyHeader.style.top = "";
          if (!announcementAbove && announcement_height) sectionAnnouncement.style.top = header_height + "px";
          return;
        }
        if (document.querySelectorAll(".section-header ~ .section-announcement").length > 0) {
          if (this.isSticky) {
            if (stickyHeader.classList.contains('header-up')) {
              stickyHeader.style.top = "calc(-1 * (var(--top-header) + var(--announcement-height)))";
              sectionAnnouncement.style.top = "0px";
            } else {
              stickyHeader.style.top = "0px";
              sectionAnnouncement.style.top = header_height + "px";
            }
          } else {
            sectionAnnouncement.style.top = "0px";
          }
        } else if (document.querySelectorAll(".section-announcement ~ .section-header").length > 0) {
          const xAnnouncementEl = document.getElementById('x-announcement');
          if (xAnnouncementEl) xAnnouncementEl.style.zIndex = 55;
          if (this.isSticky) {
            if (stickyHeader.classList.contains('header-up')) {
              stickyHeader.style.top = "calc(-1 * (var(--top-header) + var(--announcement-height)))";
            } else {
              stickyHeader.style.top = announcement_height + banner_height + "px";
            }
          }
        } else {
          if (this.isSticky) {
            if (stickyHeader.classList.contains('header-up')) {
              stickyHeader.style.top = "calc(-1 * (var(--top-header) + var(--announcement-height)))";
            } else {
              stickyHeader.style.top = announcement_height + banner_height + "px";
            }
          }
        }
      },
      handleAlwaysSticky() {
        if (this.isPinnedHeader()) return;
        const scrollPos = window.scrollY || document.documentElement.scrollTop;
        const stickyLine = document.getElementById(this.sectionId).offsetTop;
        if (scrollPos > stickyLine && !this.mobileDockExists) this.addStickyHeader();
      },
      async handelOnScrollSticky() {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        if (scrollTop < this.offsetTop) {
          requestAnimationFrame(() => {
            document.getElementById("sticky-header").classList
              .remove('sticky-header');
          });
        }

        if (Math.abs(scrollTop - this.lastScrollTop) > 10) {
          if (window.innerWidth < 1024) {
            document.getElementById('sticky-header').classList.remove('header-up', 'opacity-0');
            this.setVariableHeightHeader(true);
          } else if (scrollTop < this.lastScrollTop) {
            this.scrollDir = "up";
            document.getElementById('sticky-header').classList.remove('header-up', 'opacity-0');
            this.setVariableHeightHeader(true);
            await new Promise(r => setTimeout(r, 250));
          } else if (!this.themeModeChanged) {
            this.scrollDir = "down";
            document.getElementById('sticky-header').classList.add('header-up');
            this.setVariableHeightHeader(false);
            await new Promise(r => setTimeout(r, 250));
          }
          this.lastScrollTop = scrollTop;
        }
        this.themeModeChanged = false;
        this.setPositionTop();
      },
      addStickyHeader() {
        let isMiniCartOpen = false;
        if (Alpine.store('xMiniCart').open && this.stickyType != 'on-scroll-up') {
          isMiniCartOpen = true;
          requestAnimationFrame(() => {
            Alpine.store('xMiniCart').hideCart();
          });
        }

        requestAnimationFrame(() => {
          let stickyEl = document.getElementById("sticky-header");
          stickyEl.classList.add("sticky-header", 'reduce-logo-size');
          this.isSticky = true;
          this.showLogoTransparent = false;
        });

        requestAnimationFrame(() => {
          let stickyEl = document.getElementById("sticky-header");
          if (this.stickyType == 'on-scroll-up') {
            setTimeout(() => {
              stickyEl.classList.add('on-scroll-up-animation');
            }, 250);
          }
          if (!Alpine.store('xMiniCart').open || window.innerWidth > 768 ) {
            if (this.stickyType == 'always'
              || (this.stickyType == 'reduce-logo-size' && !this.isPinnedHeader())) stickyEl.classList.add('always-animation');
          }
        });

        if (isMiniCartOpen) {
          requestAnimationFrame(() => {
            Alpine.store('xMiniCart').openCart();
          });
        }
        requestAnimationFrame(() => {
          this.setPositionTop();
        });
      },
      watchStickyHeader() {
        if (!this.stickyCheck) {
          let queued = false;
          this.stickyCheck = () => {
            if (queued) return;
            queued = true;
            requestAnimationFrame(() => {
              queued = false;
              this.isPinnedHeader() ? this.updatePinnedHeader() : this.removeStickyHeader();
            });
          };
          window.addEventListener('scroll', this.stickyCheck, { passive: true });
          window.addEventListener('resize', this.stickyCheck);
        }
        // The theme editor re-renders the header, so re-observe on every call.
        this.stickyObservers?.forEach(observer => observer.disconnect());
        const content = document.getElementById('sticky-header-content');
        const section = content?.closest('.shopify-section');
        const resizeObserver = new ResizeObserver(this.stickyCheck);
        [content, section, ...(section ? this.previousSiblings(section) : [])].forEach(el => el && resizeObserver.observe(el));
        const classObserver = new MutationObserver(this.stickyCheck);
        if (content) classObserver.observe(content, { attributes: true, attributeFilter: ['class'] });
        this.stickyObservers = [resizeObserver, classObserver];
        this.stickyCheck();
      },
      previousSiblings(el) {
        const siblings = [];
        while ((el = el.previousElementSibling)) siblings.push(el);
        return siblings;
      },
      removeStickyHeader() {
        const scrollPos = window.scrollY || document.documentElement.scrollTop;
        const stickyLine = document.getElementById(this.sectionId)?.offsetTop;
        if (scrollPos <= stickyLine) this.releaseStickyHeader();
      },
      releaseStickyHeader() {
        this.isSticky = false;
        if (!document.getElementById("sticky-header-content")?.classList.contains('sticky-header-active')) {
          this.showLogoTransparent = true;
        } else {
          this.showLogoTransparent = false;
        }
        if (!document.getElementById("sticky-header-content")?.classList.contains('background-header')) {
          this.clickedHeader = false;
        }
        requestAnimationFrame(() => {
          document.getElementById("sticky-header").classList
            .remove('sticky-header', 'reduce-logo-size', 'always-animation', 'on-scroll-up-animation');
          this.setVariableHeightHeader(false);
          this.setPositionTop();
        });
      },
      // The header section itself is position: sticky (see sections/header.liquid), so it never leaves the viewport.
      isPinnedHeader() {
        const section = this.sectionId && document.getElementById(this.sectionId);
        return !!section && getComputedStyle(section).position == 'sticky';
      },
      updatePinnedHeader() {
        // Sticky siblings above (promo banner, announcement) move with the scroll, so measure from the first one that does not.
        let previous = document.getElementById(this.sectionId).previousElementSibling;
        let stickyAbove = 0;
        while (previous && getComputedStyle(previous).position == 'sticky') {
          stickyAbove += previous.offsetHeight;
          previous = previous.previousElementSibling;
        }
        // Count from where the header pins, which is its offset (sticky announcement or promo banner) above its flow position.
        const pinnedAt = parseFloat(document.getElementById(this.sectionId).style.top) || 0;
        const stickyLine = (previous ? previous.getBoundingClientRect().bottom + window.scrollY : 0) + stickyAbove - pinnedAt;
        const scrolled = window.scrollY - stickyLine;
        // Compacting shortens the page by the height the header loses and scroll anchoring moves scrollY by the same amount,
        // so expanding waits until that shift can no longer carry the page back over the compact threshold.
        const section = document.getElementById(this.sectionId);
        if (this.isSticky) headerHeightLost = Math.max(headerHeightLost, expandedHeaderHeight - section.offsetHeight);
        const compactAt = Math.max(50, headerHeightLost + 30);
        if (!this.isSticky && scrolled > compactAt && !this.mobileDockExists) {
          expandedHeaderHeight = section.offsetHeight;
          this.followHeaderAnimation();
          this.addStickyHeader();
        } else if (this.isSticky && scrolled <= Math.max(0, Math.min(20, compactAt - headerHeightLost - 10))) {
          this.followHeaderAnimation();
          this.releaseStickyHeader();
        }
      },
      handleChangeThemeMode() {
        this.themeModeChanged = true;
        this.reCalculateHeaderHeight();
      },
      reCalculateHeaderHeight() {
        if (!this.isTransparent) {
          document.getElementById("x-header-container").style.height = document.getElementById("sticky-header").offsetHeight + 'px';
        }
      },
      syncVariableHeightHeader() {
        const stickyHeader = document.getElementById("sticky-header");
        const headerUp = stickyHeader?.classList.contains('on-scroll-up-animation') && stickyHeader?.classList.contains('header-up');
        this.setVariableHeightHeader(this.isSticky && !headerUp);
      },
      setVariableHeightHeader(sticky) {
        let root = document.documentElement;
        let height_header = 0;
        if (sticky || this.isPinnedHeader()) {
          height_header = document.getElementById("sticky-header") ? document.getElementById("sticky-header").offsetHeight : 0;
        }
        let announcement_height = 0;
        if (document.querySelector("#x-announcement") && document.querySelector("#x-announcement")?.dataset.isSticky == 'true') {
          announcement_height = document.querySelector(".section-announcement").offsetHeight;
          height_header = announcement_height + height_header;
        }
        const promoBanner = document.querySelector(".section-promo-banner");
        const promoHeight = promoBanner && getComputedStyle(promoBanner).position == 'sticky' ? promoBanner.offsetHeight : 0;
        promoBanner?.style.setProperty('--promo-banner-top', (this.stickyBannerAboveHeader() ? announcement_height : height_header) + "px");
        // Variables on the root restyle the whole page, so they wait until the header has settled.
        if (this.isHeaderAnimating()) return;
        root.style.setProperty('--height-header', height_header + promoHeight + "px");
      },
      isHeaderAnimating() {
        return performance.now() < headerAnimatingUntil;
      },
      // Height of a sticky promo banner placed above the header, which the header then has to stick below.
      stickyBannerAboveHeader() {
        const banner = document.querySelector(".section-promo-banner");
        const header = this.sectionId && document.getElementById(this.sectionId);
        if (!banner || !header || getComputedStyle(banner).position != 'sticky') return 0;
        return banner.compareDocumentPosition(header) & Node.DOCUMENT_POSITION_FOLLOWING ? banner.offsetHeight : 0;
      },
      // The ResizeObserver lands a frame late, so follow the header on every frame while it animates its size.
      followHeaderAnimation() {
        const running = this.isHeaderAnimating();
        headerAnimatingUntil = performance.now() + 400;
        if (running) return;
        const tick = () => {
          const animating = this.isHeaderAnimating();
          this.syncVariableHeightHeader();
          if (animating) return requestAnimationFrame(tick);
          document.documentElement.style.setProperty('--header-h', document.getElementById("x-header-container").offsetHeight + 'px');
          // A sticky announcement below the header is offset by the header height, which only settles now.
          this.setPositionTop();
        };
        requestAnimationFrame(tick);
      },
      setTopStickyHeader() {
        // Only the on-scroll-up header reads --top-header, and writing it restyles the whole page.
        if (this.isPinnedHeader()) return;
        let root = document.documentElement;
        let top_height = document.getElementById("sticky-header-content").offsetHeight;
        root.style.setProperty('--top-header',top_height + "px");
      },
      setHeightScroll(el, index){
        let toggleMenu = el.querySelector('.toggle-menu-sub');
        if (!el.classList.contains('sub-menu-item')) {
          toggleMenu = el.closest(".sub-menu-item").querySelector('.toggle-menu-sub');
        }
         
        if (toggleMenu) {
          if (index) {
            if (index == 1 && el.parentElement.getBoundingClientRect().height < toggleMenu.getBoundingClientRect().height)
              el.parentElement.style.height = toggleMenu.getBoundingClientRect().height.toFixed(2) + 'px';
            return
          }
          el.parentElement.style.height = 'auto';
          if (el.parentElement.getBoundingClientRect().height < toggleMenu.getBoundingClientRect().height)
            el.parentElement.style.height = toggleMenu.getBoundingClientRect().height.toFixed(2) + 'px';
        }
      },
      setAnimationMenu(element, isSub) {
        let el = element;
        if (isSub) {
          el = el.closest(".toggle-menu").closest(".has-dropdown");
        }
        if (el.classList.contains("tabbed-animation-change")) {
          if (isSub == false) {
            if (el.querySelector(".toggle-menu") && el.querySelector(".toggle-menu").children[0]) {
              let subMenuHeight = el.querySelector(".toggle-menu")?.children[0].querySelector(".toggle-menu-sub")?.clientHeight;
              let initHeight = el.style.getPropertyValue('--init-menu-height');
              if (subMenuHeight > initHeight) {
                el.style.setProperty('--menu-height', subMenuHeight + 'px');
              } else {
                el.style.setProperty('--menu-height', initHeight + 'px');
              }
            }
          } else {
            let subMenuHeight = element.querySelector(".toggle-menu-sub")?.clientHeight;
            let initHeight = el.style.getPropertyValue('--init-menu-height');
            if (subMenuHeight > initHeight) {
              el.querySelector(".toggle-menu").style.setProperty('--menu-height', subMenuHeight + 'px');
            } else {
              el.querySelector(".toggle-menu").style.setProperty('--menu-height', initHeight + 'px');
            }
          }
        } else {
          if (isSub == false) {
            let menuHeight = el.style.getPropertyValue('--init-menu-height') ? el.style.getPropertyValue('--init-menu-height') : el.querySelector(".toggle-menu")?.children[0]?.clientHeight;
            el.style.setProperty('--menu-height', menuHeight + 'px');
          }
        }
      },
      initToggleMenuHeight(el) {
        let menuHeight = el.querySelector(".toggle-menu")?.children[0]?.clientHeight;
        el.style.setProperty('--init-menu-height', menuHeight);
      },
      tongleHorizontalHeight(el) {
        let height = el.querySelector(".toggle-menu-sub")?.offsetHeight;
        let menuHeight = el.style.getPropertyValue('--mega-menu-height').replace('px','');
        let initHeight = window.getComputedStyle(el).getPropertyValue('--init-menu-height');
        if (Number(height) + Number(menuHeight) > Number(initHeight)) {
          el.closest(".toggle-menu").style.setProperty('--menu-height', Number(height) + Number(menuHeight) + 10 + 'px');
        } else {
          el.closest(".toggle-menu").style.setProperty('--menu-height', Number(initHeight) + 'px');
        }
      }
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    // Builds the menu <template x-if> markup after load in idle time, one group per frame, for the current layout only.
    Alpine.store('xMenuBuild', {
      mega: false,
      mobile: false,
      store: false,
      mobilePanels: 0,
      menuImages: false,
      initRunDone: false,
      running: false,
      designMode: false,
      desktopQuery: window.matchMedia('(min-width: 1024px)'),
      start(designMode) {
        this.designMode = designMode;
        if (designMode) {
          this.showMenuImages();
          document.addEventListener('shopify:section:load', () => {
            this.reset();
            setTimeout(() => this.buildAll(), 0);
          });
          // Let the init-run listeners register first.
          setTimeout(() => this.buildAll(), 0);
          return;
        }
        this.desktopQuery.addEventListener('change', () => this.schedule());
        if (document.readyState === 'complete') {
          this.schedule();
        } else {
          window.addEventListener('load', () => this.schedule(), { once: true });
          setTimeout(() => this.schedule(), 3000);
        }
      },
      // The store selector teleports into the mobile menu, so it must be built after it.
      pending() {
        const mobileGroups = () => ['mobile', 'store', 'mobilePanels'].filter(group => group === 'mobilePanels' ? this.nextPanel() : !this[group]);
        if (this.designMode) {
          return [...(this.mega ? [] : ['mega']), ...mobileGroups()];
        }
        if (this.desktopQuery.matches) {
          return this.mega ? [] : ['mega'];
        }
        // The cart template hides the menu button.
        const menuButton = document.querySelector('#mobile-navigation:not(.menu-drawer)');
        if (!this.mobile && (!menuButton || menuButton.classList.contains('hidden'))) {
          return [];
        }
        return mobileGroups();
      },
      nextPanel() {
        if (!this.mobile || this.mobilePanels === Infinity) return;
        const next = [...document.querySelectorAll('template[data-mobile-panel]')]
          .map(template => Number(template.dataset.mobilePanel))
          .find(index => index > this.mobilePanels);
        if (next === undefined) {
          this.mobilePanels = Infinity;
        }
        return next;
      },
      build(group) {
        if (group === 'mobilePanels') {
          this.mobilePanels = this.nextPanel();
        } else {
          this.fill(group);
          this[group] = true;
        }
      },
      // MFS-660: menu markup is printed after </main>; move it back before x-if copies it.
      fill(group) {
        document.querySelectorAll(`template[data-menu-group="${group}"]`).forEach(template => {
          if (template.content.childElementCount) return;
          const holder = document.getElementById(`menu-src-${template.dataset.menuSrc}`);
          if (!holder) return;
          template.content.append(holder.content);
          holder.remove();
        });
      },
      // Hidden menus are close enough to the viewport for lazy loading to fetch their images, so CSS keeps them
      // display: none until this runs.
      showMenuImages() {
        if (this.menuImages) return;
        this.menuImages = true;
        document.documentElement.classList.add('menu-images');
      },
      runInit() {
        if (this.initRunDone) return;
        this.initRunDone = true;
        document.body.dispatchEvent(new CustomEvent('init-run', { bubbles: true, composed: true, cancelable: true }));
      },
      buildAll() {
        this.runInit();
        const groups = this.pending();
        groups.filter(group => group !== 'mobilePanels').forEach(group => {
          this.fill(group);
          this[group] = true;
        });
        // Panel templates only exist once the drawer is built.
        if (groups.includes('mobile') || groups.includes('mobilePanels')) {
          this.mobilePanels = Infinity;
        }
      },
      schedule() {
        if (this.running) return;
        this.running = true;
        const idle = (callback) => window.requestIdleCallback ? requestIdleCallback(callback, { timeout: 2000 }) : setTimeout(callback, 50);
        // Each group's style and layout work gets its own frame.
        const nextFrame = (callback) => requestAnimationFrame(() => setTimeout(() => idle(callback), 0));
        const step = () => {
          if (!this.initRunDone) {
            this.runInit();
            nextFrame(step);
            return;
          }
          const group = this.pending()[0];
          if (!group) {
            this.running = false;
            return;
          }
          this.build(group);
          nextFrame(step);
        };
        idle(step);
      },
      // Only header interactions need the markup immediately; anything else waits for the idle build.
      interact(event) {
        if (!this.menuImages && (this.designMode || event.target.closest?.('.section-header'))) {
          this.showMenuImages();
        }
        const initRunWasDone = this.initRunDone;
        const megaWasBuilt = this.mega;
        const mobileWasBuilt = this.mobile;
        this.runInit();
        if (!this.pending().length) return;
        if (!this.designMode && !event.target.closest?.('.section-header')) return;
        if (event.type === 'touchstart') {
          // The tap that triggers the build can be lost, so repeat it once the markup exists. The menu button
          // toggles, so it is only repeated when its own click did not arrive.
          const target = event.target;
          const parent = target.parentNode;
          let retarget = '';
          // #SearchOpen only renders with Nosto search off; a tap while its init-run content is still loading is not repeated.
          if (!initRunWasDone && (parent?.parentNode?.id == 'SearchOpen' || parent?.id == 'SearchOpen')) {
            retarget = '#SearchOpen';
          } else if (!initRunWasDone && (parent?.parentNode?.id == 'cart-icon' || parent?.id == 'cart-icon')) {
            retarget = '#cart-icon';
          } else if (!mobileWasBuilt && (parent?.id == 'mobile-navigation' || target.id == 'mobile-navigation')) {
            retarget = '#mobile-navigation';
          }
          if (retarget) {
            const button = target.closest(retarget) || document.querySelector(retarget);
            let clicked = false;
            if (retarget === '#mobile-navigation') {
              button.addEventListener('click', () => { clicked = true; }, { capture: true, once: true });
            }
            setTimeout(() => { if (!clicked) button.click(); }, 200);
          }
        }
        this.buildAll();
        // The hovered or focused menu item ran its handler before its dropdown existed, so run it again.
        if (!megaWasBuilt && this.mega && event.type !== 'touchstart') {
          Alpine.nextTick(() => event.target.dispatchEvent(new event.constructor(event.type, { bubbles: true })));
        }
      },
      reset() {
        this.mega = false;
        this.mobile = false;
        this.store = false;
        this.mobilePanels = 0;
        this.initRunDone = false;
      }
    });

    let mobileNavInert = [];

    Alpine.store('xMobileNav', {
      show: false,
      loading: false,
      currentMenuLinks: [],
      open() {
        Alpine.store('xMenuBuild').showMenuImages();
        Alpine.store('xMenuBuild').buildAll();
        const headerContainer = document.getElementById('x-header-container');
        if (headerContainer) {
          document.documentElement.style.setProperty('--header-h', Math.max(headerContainer.offsetHeight, headerContainer.getBoundingClientRect().bottom) + 'px');
        }
        this.show = true;
        Alpine.store('xPopup').open = true;
        Alpine.nextTick(() => {
          const drawer = document.querySelector('#mobile-navigation.menu-drawer');
          if (this.show && drawer) Alpine.store('xFocusElement').trapFocus(drawer, drawer);
        });
      },
      close() {
        this.show = false;
        Alpine.store('xPopup').close();
        Alpine.store('xFocusElement').releaseContainer(
          document.querySelector('#mobile-navigation.menu-drawer'),
          document.querySelector('#mobile-navigation:not(.menu-drawer)')
        );
      },
      setActiveLink(linkId) {
        this.currentMenuLinks.push(linkId);
        Alpine.nextTick(() => {
          this.syncInert();
          requestAnimationFrame(() => {
            document.querySelector(`[data-mobile-submenu="${linkId}"] [data-mobile-submenu-back]`)?.focus({ preventScroll: true });
          });
        });
      },
      removeActiveLink(linkId) {
        const index = this.currentMenuLinks.indexOf(linkId);
        if (index !== -1) {
          this.currentMenuLinks.splice(index, 1);
        }
        const panel = document.querySelector(`[data-mobile-submenu="${linkId}"]`);
        const hadFocus = !!panel && panel.contains(document.activeElement);
        this.syncInert();
        if (hadFocus) {
          document.querySelector(`[data-mobile-submenu-toggle="${linkId}"]`)?.focus({ preventScroll: true });
        }
      },
      resetMenu() {
        this.currentMenuLinks = [];
        this.syncInert();
      },
      syncInert() {
        mobileNavInert.forEach((el) => { el.inert = false; });
        mobileNavInert = [];
        const drawer = document.querySelector('#mobile-navigation.menu-drawer');
        const panel = [...this.currentMenuLinks].reverse()
          .map((id) => document.querySelector(`[data-mobile-submenu="${id}"]`))
          .find(Boolean);
        if (!drawer || !panel) return;
        for (let el = panel; el && el !== drawer; el = el.parentElement) {
          for (const sibling of el.parentElement.children) {
            if (sibling !== el && !sibling.inert) {
              sibling.inert = true;
              mobileNavInert.push(sibling);
            }
          }
        }
      },
      scrollTop(el = null) { 
        document.getElementById('menu-navigation').scrollTop = 0; 
        if (el) {
          el.closest('.scrollbar-body').scrollTop = 0;
        }
      }
    });

    Alpine.store('xPopup', {
      open: false,
      setWidthScrollbar() {
        const root = document.documentElement;
        const clientWidth = root.clientWidth;
        const width = Math.abs(window.innerWidth - clientWidth);
        root.style.setProperty('--width-scrollbar', width + "px");
      },
      close() {
        setTimeout(() => {
          this.open = false;
        }, 500);
      }
    }); 

    Alpine.store('xShowCookieBanner', {
      show: false
    });

    Alpine.store('xMiniCart', {
      open: false,
      type: '',
      loading: false,
      needReload: false,
      reLoad() {
        this.loading = true;
        const sections = Alpine.store('xCartHelper').getSectionsToRender().map(s => s.id).join(',');
        fetch(`${window.location.pathname}?sections=${sections}`)
        .then(response => response.json())
        .then(response => {
          requestAnimationFrame(() => {
            setTimeout(() => {
              Alpine.store('xCartHelper').swapSections(response);
              this.loading = false;
            }, 0)
          });
        });
      },
      openCart() {
        if (window.location.pathname != '/cart') {        
          requestAnimationFrame(() => {
            if (Alpine.store('xQuickView') && Alpine.store('xQuickView').show) {
              Alpine.store('xQuickView').show = false;
            }
          });

          requestAnimationFrame(() => {
            document.getElementById('sticky-header').classList.remove('on-scroll-up-animation');

            if (window.innerWidth < 768 || this.type == "drawer") {
              setTimeout(() => {
                Alpine.store('xPopup').open = true;
              }, 50);
            }

            requestAnimationFrame(() => {
              document.getElementById('sticky-header').classList.remove('header-up');
              this.open = true;
            });
            
            if (Alpine.store('xHeaderMenu').stickyType == 'on-scroll-up') {
              setTimeout(() => {
                requestAnimationFrame(() => {
                  document.getElementById('sticky-header').classList.add('on-scroll-up-animation');
                });
              }, 200);
            }
          });
        }
      },
      hideCart() {
        requestAnimationFrame(() => {
          this.open = false;
          Alpine.store('xPopup').close();
        });
      }
    });

    Alpine.store('xModal', {
      activeElement: "",
      focused: false,
      setActiveElement(element) {
        this.activeElement = element;
      },
      focus(container, elementFocus) {
        this.focused = true;
        Alpine.store('xFocusElement').trapFocus(container, elementFocus);
      },
      removeFocus() {
        this.focused = false;
        const openedBy = document.getElementById(this.activeElement);
        this.activeElement = "";
        Alpine.store('xFocusElement').removeTrapFocus(openedBy);
      }
    });

    const focusTrapState = {
      container: null,
      returnFocus: null,
      stack: [],
      pointer: false,
      listeners: {}
    };

    Alpine.store('xFocusElement', {
      focusableElements: 'button, [href], input, select, textarea, iframe, [tabindex]:not([tabindex^="-"])',
      resolve(element) {
        return typeof element === 'string' ? document.getElementById(element) : element;
      },
      isRendered(element) {
        return !!element && element.isConnected && element.getClientRects().length > 0;
      },
      getFocusable(container) {
        return Array.from(container.querySelectorAll(this.focusableElements)).filter((el) =>
          el.tabIndex >= 0 &&
          !el.disabled &&
          !el.closest('[inert]') &&
          this.isRendered(el) &&
          getComputedStyle(el).visibility !== 'hidden'
        );
      },
      inOtherModal(element, trap) {
        const modal = element && element.closest ? element.closest('[aria-modal="true"]') : null;
        return !!modal && !trap.contains(modal) && !modal.contains(trap);
      },
      isTrapping(container) {
        const c = this.resolve(container);
        return !!c && focusTrapState.container === c;
      },
      trapFocus(container, elementFocus) {
        const c = this.resolve(container);
        if (!c) return;
        const e = this.resolve(elementFocus);
        const active = document.activeElement;

        if (focusTrapState.container !== c) {
          focusTrapState.stack = focusTrapState.stack.filter((entry) => entry.container !== c);
          if (focusTrapState.container && this.isRendered(focusTrapState.container)) {
            focusTrapState.stack.push({ container: focusTrapState.container, returnFocus: focusTrapState.returnFocus });
          }
          focusTrapState.returnFocus = active && active !== document.body && !c.contains(active) ? active : null;
        }

        this.bind(c);

        if (active && active !== c && c.contains(active)) return;

        if (!c.hasAttribute('tabindex')) c.setAttribute('tabindex', '-1');
        (this.isRendered(e) ? e : c).focus({ preventScroll: true });
      },
      bind(c) {
        this.release();
        focusTrapState.container = c;

        focusTrapState.listeners.pointerdown = () => {
          focusTrapState.pointer = true;
        };

        focusTrapState.listeners.keydown = (event) => {
          focusTrapState.pointer = false;
          if (event.key !== 'Tab') return;
          if (!this.isRendered(focusTrapState.container)) {
            this.dropTrap();
            return;
          }

          const trap = focusTrapState.container;
          const current = document.activeElement;
          if (!trap.contains(current) && this.inOtherModal(current, trap)) return;

          const elements = this.getFocusable(trap);
          if (!elements.length) {
            event.preventDefault();
            trap.focus({ preventScroll: true });
            return;
          }

          const first = elements[0];
          const last = elements[elements.length - 1];

          if (!trap.contains(current)) {
            event.preventDefault();
            (event.shiftKey ? last : first).focus();
          } else if (event.shiftKey && (current === first || current === trap)) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && current === last) {
            event.preventDefault();
            first.focus();
          }
        };

        focusTrapState.listeners.focusin = (event) => {
          const trap = focusTrapState.container;
          if (!this.isRendered(trap)) {
            this.dropTrap();
            return;
          }
          if (focusTrapState.pointer || trap.contains(event.target)) return;
          if (this.inOtherModal(event.target, trap)) return;

          (this.getFocusable(trap)[0] || trap).focus({ preventScroll: true });
        };

        document.addEventListener('pointerdown', focusTrapState.listeners.pointerdown, true);
        document.addEventListener('keydown', focusTrapState.listeners.keydown);
        document.addEventListener('focusin', focusTrapState.listeners.focusin);
      },
      release() {
        const { listeners } = focusTrapState;
        if (listeners.pointerdown) document.removeEventListener('pointerdown', listeners.pointerdown, true);
        if (listeners.keydown) document.removeEventListener('keydown', listeners.keydown);
        if (listeners.focusin) document.removeEventListener('focusin', listeners.focusin);
        focusTrapState.listeners = {};
        focusTrapState.container = null;
        focusTrapState.pointer = false;
      },
      dropTrap() {
        this.release();
        focusTrapState.returnFocus = null;
        while (focusTrapState.stack.length) {
          const previous = focusTrapState.stack.pop();
          if (this.isRendered(previous.container)) {
            focusTrapState.returnFocus = previous.returnFocus;
            this.bind(previous.container);
            return previous.container;
          }
        }
        return null;
      },
      removeTrapFocus(elementToFocus = null) {
        if (!focusTrapState.container) return;

        const { container, returnFocus } = focusTrapState;
        const previous = this.dropTrap();
        const restored = [elementToFocus, returnFocus].some((target) => {
          if (!target || !target.isConnected) return false;
          target.focus();
          return document.activeElement === target;
        });
        if (restored) return;
        if (previous) {
          (this.getFocusable(previous)[0] || previous).focus({ preventScroll: true });
        } else if (container.contains(document.activeElement)) {
          document.activeElement.blur();
        }
      },
      releaseContainer(container, elementToFocus = null) {
        const c = this.resolve(container);
        if (!c) return;
        if (focusTrapState.container === c) {
          this.removeTrapFocus(elementToFocus);
        } else {
          focusTrapState.stack = focusTrapState.stack.filter((entry) => entry.container !== c);
        }
      }
    });

    Alpine.data('xTruncateText', () => ({
      truncateEl: "",
      truncateInnerEl: "",
      truncated: false,
      truncatable: false,
      label: "",
      expanded: false,
      load(truncateEl) {
        const truncateRect = truncateEl.getBoundingClientRect();
        truncateEl.style.setProperty("--truncate-height", `${truncateRect.height}px`);
      },
      setTruncate(element) {
        if (element.offsetHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth) {
          this.truncated = true;
          this.truncatable = true;
          this.expanded = false;
        } else {
          this.truncated = false;
          this.truncatable = false
          this.expanded = true;;
        }
      },
      open(el, newLabel) {
        const truncateEl = el.closest('.truncate-container').querySelector('.truncate-text');
        this.expanded = true;
        this.label = newLabel;
        if (truncateEl.classList.contains('truncate-expanded')) {
          this.truncated = true;
        } else {
          const truncateInnerEl = truncateEl.querySelector('.truncate-inner');
          window.requestAnimationFrame(() => {
            const truncateInnerRect = truncateInnerEl.getBoundingClientRect();
            truncateEl.style.setProperty("--truncate-height-expanded", `${truncateInnerRect.height}px`);
            truncateEl.classList.add('truncate-expanded');
          });
          this.truncated = false;
        }
      },
      close(el, newLabel, isQuickview = false) {
        this.label = newLabel;
        const truncateEl = el.closest('.truncate-container').querySelector('.truncate-text');
        const isInViewport = () => {
          const rect = truncateEl.getBoundingClientRect();
          return (rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth))
        }
        this.truncated = true;
        if (!isInViewport() && !isQuickview) {
          const scrollPosition = truncateEl.getBoundingClientRect().top + window.scrollY - 500 ;
          window.scrollTo({
            top: scrollPosition,
            behavior: 'smooth'
        });
        truncateEl.style.transition = 'none'
          setTimeout(() => {
            truncateEl.style.transition = ''
          }, 1000)
        }
        truncateEl.classList.remove('truncate-expanded');
        this.expanded = false;
      }
    }));

    Alpine.store('xPopupPriceDetail', {
      open: false,
      cachedResults: [],
      show(event, productID, price, priceMax, priceMiddle, priceMin, shopUrl, pageHandle) {
        event.preventDefault()
        let content = document.getElementById("popup-price-content");
        if (this.cachedResults[productID]) {
          content.innerHTML = this.cachedResults[productID];
          this.open = true;
          return true;
        }

        let url = `${shopUrl}/pages/${pageHandle}`;
        fetch(url, {
          method: 'GET'
        }).then(
          response => response.text()
        ).then(responseText => {
          const html = (new DOMParser()).parseFromString(responseText, 'text/html');
          const textContent = html.querySelector(".page__container .page__body>div").innerHTML;
          let updatedContent = textContent.replace("{price}", `${price}`).replace("{max_price}", `${priceMax}`).replace("{middle_price}", `${priceMiddle}`).replace("{min_price}", `${priceMin}`);
          
          content.innerHTML = updatedContent;
          this.cachedResults[productID] = updatedContent;
        }).finally(() => {
          this.open = true;
        })
      },
      close() {
        this.open = false;
      }
    });
    
    Alpine.store("xEstimateDelivery", {
      hour: 0,
      minute: 0,
      noti: '',
      countdownCutOffTime(cutOffHour, cutOffMinute, hrsText, minsText) {
        if (this.noti != '')
          return;
        const now = new Date();
        const currentHour = now.getHours();
        const currentMinute = now.getMinutes();

        const current = new Date(now.getFullYear(), now.getMonth(), now.getDate(), currentHour, currentMinute);
        const cutOff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutOffHour, cutOffMinute);

        if (current >= cutOff) {
          cutOff.setDate(cutOff.getDate() + 1);
        }

        const diffMs = cutOff - current;
        
        this.hour = Math.floor(diffMs / 1000 / 60 / 60);
        this.minute = Math.floor((diffMs / 1000 / 60) % 60);
        return this.hour > 0 ? this.noti = this.hour + ' ' + hrsText + ' ' + this.minute + ' ' + minsText : this.noti = this.minute + ' ' + minsText;
      }
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xCartAnalytics', {
      viewCart() {
        window.CartState.get().then(cart => {
          if (cart.items.length > 0) {
            Shopify.analytics.publish('view_cart', {'cart': cart});
          }
        });
      }
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xCustomerEvent', {
      fire(eventName, el, data) {
        if (Shopify.designMode) return;
        
        const formatedData = data ? data : xParseJSON(el.getAttribute('x-customer-event-data'));
        Shopify.analytics.publish(eventName, formatedData);
      }
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xSplide', {
      load(el, configs) {
        const initSlider = () => {
          const id = el.getAttribute("id");
          if(configs.classes != undefined) {
            if (!configs.classes.arrow) configs.classes.arrow = "arrow w-8 h-8 p-2 absolute z-10 top-1/2 -translate-y-1/2 hidden md:flex items-center justify-center";
            if (!configs.classes.next) configs.classes.next = "right-0";
            if (!configs.classes.prev) configs.classes.prev = "-rotate-180";
          }
          let splide = new Splide("#" + id, configs);
          if (configs.thumbs) {
            let thumbsRoot = document.getElementById(configs.thumbs);
            let thumbs = thumbsRoot.getElementsByClassName('x-thumbnail');
            let current;
            let _this = this;

            for (let i = 0; i < thumbs.length; i++) {
              if (thumbs[i] == current) {
                thumbs[i].classList.remove('opacity-30');
              } else {
                thumbs[i].classList.add('opacity-30');
              }
              thumbs[i].addEventListener('click', function () {
                _this.moveThumbnail(i, thumbs[i], thumbsRoot, configs.thumbs_direction, configs.direction);
                splide.go(i);
              });
            }

            splide.on('refresh', function () {
              for (let i = 0; i < thumbs.length; i++) {
                thumbs[i].removeEventListener('click', function () {
                  _this.moveThumbnail(i, thumbs[i], thumbsRoot, configs.thumbs_direction, configs.direction);
                  splide.go(i);
                });
              }

              let thumbsRoot = document.getElementById(configs.thumbs);
              let thumbsNew = thumbsRoot.getElementsByClassName('x-thumbnail');

              for (let i = 0; i < thumbsNew.length; i++) {
                if (i == 0) {
                  thumbsNew[i].classList.remove('opacity-30');
                } else {
                  thumbsNew[i].classList.add('opacity-30');
                }
                
                thumbsNew[i].addEventListener('click', function () {
                  _this.moveThumbnail(i, thumbsNew[i], thumbsRoot, configs.thumbs_direction, configs.direction);
                  splide.go(i);
                });
              }
            })
            splide.on('mounted move', function () {
              let thumbnail = thumbs[splide.index];
              if (thumbnail) {
                if (current) {
                  current.classList.add('opacity-30');
                }
                thumbnail.classList.remove('opacity-30');
                current = thumbnail;
                _this.moveThumbnail(splide.index, thumbnail, thumbsRoot, configs.thumbs_direction, configs.direction);
              }
            });
          }

          if (configs.hotspot) {
            let hotspotRoot = document.getElementById(configs.hotspot);
            let hotspots = hotspotRoot.getElementsByClassName('x-hotspot');
            let current;

            if (configs.disableHoverOnTouch && (('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints)) {
              for (let i = 0; i < hotspots.length; i++) {
                hotspots[i].addEventListener('click', function () {
                  splide.go(i);
                });
              }
            } else {
              for (let i = 0; i < hotspots.length; i++) {
                hotspots[i].addEventListener('mouseover', function () {
                  splide.go(i);
                });
                hotspots[i].addEventListener('focus', function () {
                  splide.go(i);
                });
              }             
            }
            splide.on('mounted move', function () {
              let hotspot = hotspots[splide.index];
              
              if (hotspot) {
                if (current) {
                  current.classList.remove('active-hotspot');
                }
                hotspot.classList.add('active-hotspot');
                current = hotspot;
              }
            });
          }
          if (configs.cardHover) {
            let cardImage = document.getElementById(configs.cardHover);
            if (window.innerWidth > 1024) {
              cardImage.addEventListener('mousemove', function (e) {
                let left = e.offsetX;
                let width = cardImage.getBoundingClientRect().width;
                let spacing = left / width;
                let index = Math.floor(spacing * configs.maxSlide);
                splide.go(index);
              });
              cardImage.addEventListener('mouseleave', function (e) {
                splide.go(0);
              });
            }
          }
          if (configs.progressBar) {
            var bar = splide.root.querySelector( '.splide-progress-bar' );
            splide.on( 'mounted move', function () {
              var end  = configs.progressBar;
              if (configs.progressBarHeader) {
                end  = splide.Components.Slides.getLength();
              }
              var rate = 100 * (splide.index / end);
              if (bar) {
                var widthBar =  window.getComputedStyle(bar).getPropertyValue('width').replace("px", '');
                var widthProgressBar = window.getComputedStyle(bar.closest('.splide-progress')).getPropertyValue('width').replace("px", '');
                var percentBar = 100 * (Number(widthBar) /  Number(widthProgressBar));
                var rateBar = rate + percentBar;
                var maxRate = 100 - percentBar;
                if(rateBar > 100 ) {
                  rate = maxRate;
                }
                if(document.querySelector('body').classList.contains('rtl')) {
                  bar.style.marginRight = rate + '%';
                }else {
                  bar.style.marginLeft = rate + '%';
                }  
              }
            });
          }
          if(el.classList.contains('card-product-img')) {
            splide.on('resized', function() { 
              var height = splide.root.querySelector('.splide__track').offsetHeight;
              splide.Components.Slides.get().forEach((item) => {
                item.slide.style.height = height+"px";
              });
            }) 
          }

          if (configs.events) {
            configs.events.forEach((e) => {
              splide.on(e.event, e.callback);
            });
          }

          
          el.splide = splide;
          splide.mount();
          if (configs.videoProduct) {
            const move = splide.Components.Move;
            move.translate(move.toPosition(0));  
          }

          if (configs.playOnHover) {
            splide.Components.Autoplay.pause();
            el.onmouseover = function() {
              splide.Components.Autoplay.play();
            };
            el.onmouseout = function() {
              splide.Components.Autoplay.pause();
            };
          }
        }

        if (!window.Eurus.loadedScript.has('slider')) {
          deferScriptLoad('slider', window.Eurus.sliderScript, initSlider, true);
        } else if (window.Splide){
          initSlider();
        } else {
          document.addEventListener('slider loaded', () => {
            initSlider();
          });
        }
      },
      togglePlayPause(el) {
        if (!el || !el.splide || !el.splide.Components.Autoplay) return;
      
        const splide = el.splide;
        const autoplay = splide.Components.Autoplay;
      
        if (autoplay.isPaused()) {
          autoplay.play();
        } else {
          splide.go(0);
          autoplay.pause();
        }
      },
      moveThumbnail(index, thumbnail, thumbsRoot, direction) {
        if (thumbnail) {
          if (direction == 'vertical') {
            setTimeout(() => {
              thumbsRoot.scrollTop = (index + 1) * thumbnail.offsetHeight - thumbsRoot.offsetHeight * 0.5 + thumbnail.offsetHeight * 0.5 + index * 12;
            },50);
          } else {
            thumbsRoot.scrollLeft = (index - 2) * thumbnail.offsetWidth;
          }
        }
      }
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('xParallax', () => ({
      debounce(func, wait) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
              timeout = null;
              func.apply(context, args);
            };
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
        };
      },
      load(disable) {
        if (disable) return;

        if ("IntersectionObserver" in window && 'IntersectionObserverEntry' in window) {
          const observerOptions = {
            root: null,
            rootMargin: '0px 0px',
            threshold: 0
          };

          var observer = new IntersectionObserver(handleIntersect, observerOptions);
          var el;
          function handleIntersect(entries) {
            entries.forEach(function(entry) {
              if (entry.isIntersecting) {
                el = entry.target;
                window.addEventListener('scroll', parallax, {passive: true, capture: false});
              } else {
                window.removeEventListener('scroll', parallax, {passive: true, capture: false});
              }
            });
          }

          observer.observe(this.$el);
          
          var parallax = this.debounce(function() {
            var rect = el.getBoundingClientRect();
            var speed = (window.innerHeight / el.parentElement.offsetHeight) * 20;
            var shiftDistance = (rect.top - window.innerHeight) / speed;
            var maxShiftDistance = el.parentElement.offsetHeight / 11;
            
            if (shiftDistance < -maxShiftDistance || shiftDistance > maxShiftDistance) {
              shiftDistance = -maxShiftDistance;
            }
            
            el.style.transform = 'translate3d(0, '+ shiftDistance +'px, 0)';
          }, 10);
        }
      }
    }));
  });
});

requestAnimationFrame(() => {
  // Optimize INP
  document.addEventListener('alpine:init', () => {
    Alpine.store('xDOM', {
      rePainting: null, // String: alias element re-painting.
    })
  })
})
